var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "content" } }, [
    _c("div", { staticClass: "header col-md-12" }, [
      _c(
        "div",
        { staticClass: "header-inner row align-items-center" },
        [
          _c("div", { staticClass: "col left" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("sidebar.stockcontrols")) +
                  " " +
                  _vm._s("> " + _vm.warehouse_name) +
                  "\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _vm.device.isMobile
            ? [
                _c("div", { staticClass: "col-4 right" }, [
                  _c("div", { staticClass: "action" }, [
                    _c(
                      "div",
                      {
                        staticClass: "dropdown item",
                        attrs: { id: "dropdownOptions" }
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn no-bg dropdown-toggle text-secondary shake",
                            attrs: {
                              id: "dropdownMenuButton",
                              type: "button",
                              "data-toggle": "dropdown",
                              "aria-haspopup": "true",
                              "aria-expanded": "false"
                            }
                          },
                          [
                            _c("i", { staticClass: "fas fa-cog" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "name" }, [
                              _vm._v(_vm._s(_vm.$t("button.options")))
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "dropdown-menu dropdown-menu-right",
                            attrs: { "aria-labelledby": "dropdownMenuButton" }
                          },
                          [
                            _vm.hasRoleEdit
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "dropdown-item",
                                    on: {
                                      click: function($event) {
                                        return _vm.openAdjustmentModal(
                                          null,
                                          null
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("i", { staticClass: "fas fa-redo-alt" }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "name" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "apps.inventory.message.adjustmentstock"
                                          )
                                        )
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hasRoleEdit
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "dropdown-item",
                                    on: {
                                      click: function($event) {
                                        return _vm.openTransferModal()
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-exchange-alt"
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "name" }, [
                                      _vm._v(_vm._s(_vm.$t("button.transfer")))
                                    ])
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hasRoleEdit
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "dropdown-item",
                                    on: {
                                      click: function($event) {
                                        return _vm.openIssueModal(
                                          null,
                                          "manual issue"
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-sign-out-alt"
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "name" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "apps.inventory.message.manualissue"
                                          )
                                        )
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hasRoleEdit
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "dropdown-item",
                                    on: {
                                      click: function($event) {
                                        return _vm.openIssueModal(
                                          null,
                                          "manual return"
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-sign-in-alt",
                                      staticStyle: {
                                        transform: "rotate(180deg)"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "name" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "apps.inventory.message.manualreturn"
                                          )
                                        )
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "dropdown-item",
                                attrs: { disabled: _vm.isDisabledPrint },
                                on: {
                                  click: function($event) {
                                    return _vm.openPrintModal()
                                  }
                                }
                              },
                              [
                                _vm.isDisabledPrint
                                  ? _c("i", {
                                      staticClass: "fas fa-spinner spin"
                                    })
                                  : _c("i", { staticClass: "fas fa-print" }),
                                _vm._v(" "),
                                _c("span", { staticClass: "name" }, [
                                  _vm._v(_vm._s(_vm.$t("button.print")))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "dropdown-item",
                                attrs: { disabled: _vm.isDisabledExport },
                                on: {
                                  click: function($event) {
                                    return _vm.exportAs("xlsx")
                                  }
                                }
                              },
                              [
                                _vm.isDisabledExport
                                  ? _c("i", {
                                      staticClass: "fas fa-spinner spin"
                                    })
                                  : _c("i", { staticClass: "fas fa-download" }),
                                _vm._v(" "),
                                _c("span", { staticClass: "name" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("button.download")) + " Excel"
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "dropdown-item",
                                attrs: { disabled: _vm.isDisabledExport },
                                on: {
                                  click: function($event) {
                                    return _vm.exportAs("csv")
                                  }
                                }
                              },
                              [
                                _vm.isDisabledExport
                                  ? _c("i", {
                                      staticClass: "fas fa-spinner spin"
                                    })
                                  : _c("i", { staticClass: "fas fa-download" }),
                                _vm._v(" "),
                                _c("span", { staticClass: "name" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("button.download")) + " CSV"
                                  )
                                ])
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ])
                ])
              ]
            : [
                _c("div", { staticClass: "col-8 right" }, [
                  _c("div", { staticClass: "action" }, [
                    _vm.hasRoleEdit
                      ? _c("div", { staticClass: "dropdown nodro item" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn no-bg text-secondary",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.openIssueModal(
                                    null,
                                    "manual return"
                                  )
                                }
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "fas fa-sign-in-alt",
                                staticStyle: { transform: "rotate(180deg)" }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "name" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "apps.inventory.message.manualreturn"
                                    )
                                  )
                                )
                              ])
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hasRoleEdit
                      ? _c("div", { staticClass: "dropdown nodro item" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn no-bg text-secondary",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.openIssueModal(
                                    null,
                                    "manual issue"
                                  )
                                }
                              }
                            },
                            [
                              _c("i", { staticClass: "fas fa-sign-out-alt" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "name" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("apps.inventory.message.manualissue")
                                  )
                                )
                              ])
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hasRoleEdit
                      ? _c("div", { staticClass: "dropdown nodro item" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn no-bg text-secondary",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.openTransferModal()
                                }
                              }
                            },
                            [
                              _c("i", { staticClass: "fas fa-exchange-alt" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "name" }, [
                                _vm._v(_vm._s(_vm.$t("button.transfer")))
                              ])
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hasRoleEdit
                      ? _c("div", { staticClass: "dropdown nodro item" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn no-bg text-secondary",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.openAdjustmentModal(null, null)
                                }
                              }
                            },
                            [
                              _c("i", { staticClass: "fas fa-redo-alt" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "name" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "apps.inventory.message.adjustmentstock"
                                    )
                                  )
                                )
                              ])
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "dropdown item" }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn no-bg dropdown-toggle text-secondary",
                          attrs: {
                            id: "dropdownMenuButton",
                            disabled: _vm.isDisabledExport,
                            type: "button",
                            "data-toggle": "dropdown",
                            "aria-haspopup": "true",
                            "aria-expanded": "false"
                          }
                        },
                        [
                          _vm.isDisabledExport
                            ? _c("i", { staticClass: "fas fa-spinner spin" })
                            : _c("i", { staticClass: "fas fa-download" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "name" }, [
                            _vm._v(_vm._s(_vm.$t("button.download")))
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "dropdown-menu dropdown-menu-right",
                          attrs: { "aria-labelledby": "dropdownMenuButton" }
                        },
                        [
                          _c(
                            "a",
                            {
                              class: [
                                "dropdown-item",
                                { disabled: _vm.isDisabledExport }
                              ],
                              on: {
                                click: function($event) {
                                  return _vm.exportAs("xlsx")
                                }
                              }
                            },
                            [
                              _c("span", { staticClass: "text-secondary" }, [
                                _vm._v("Excel")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              class: [
                                "dropdown-item",
                                { disabled: _vm.isDisabledExport }
                              ],
                              on: {
                                click: function($event) {
                                  return _vm.exportAs("csv")
                                }
                              }
                            },
                            [
                              _c("span", { staticClass: "text-secondary" }, [
                                _vm._v("CSV")
                              ])
                            ]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "dropdown nodro item" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn no-bg text-secondary",
                          attrs: {
                            disabled: _vm.isDisabledPrint,
                            type: "button"
                          },
                          on: {
                            click: function($event) {
                              return _vm.openPrintModal()
                            }
                          }
                        },
                        [
                          _vm.isDisabledPrint
                            ? _c("i", { staticClass: "fas fa-spinner spin" })
                            : _c("i", { staticClass: "fas fa-print" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "name" }, [
                            _vm._v(_vm._s(_vm.$t("button.print")))
                          ])
                        ]
                      )
                    ])
                  ])
                ])
              ]
        ],
        2
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "content col-md-12" },
      [
        !_vm.ready
          ? _c("p", [_vm._v(_vm._s(_vm.$t("message.loading")))])
          : _vm._e(),
        _vm._v(" "),
        _vm.ready
          ? _c("div", { staticClass: "row mb-3" }, [
              _c("div", { staticClass: "col-lg-4 ml-auto" }, [
                _c(
                  "label",
                  { staticClass: "d-flex d-flex align-items-center" },
                  [
                    _c("span", { staticClass: "mr-2" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("message.search")) +
                          ":\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _c("base-input", {
                      attrs: {
                        placeholder: _vm.$t("placeholder.searchstock"),
                        type: "text",
                        clear: ""
                      },
                      on: {
                        onEnter: _vm.handleSearchEnter,
                        onClear: _vm.handleSearchClear
                      },
                      model: {
                        value: _vm.query.q,
                        callback: function($$v) {
                          _vm.$set(_vm.query, "q", $$v)
                        },
                        expression: "query.q"
                      }
                    })
                  ],
                  1
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.ready
          ? _c("base-table", {
              attrs: { pagination: _vm.$store.state.app.pagination },
              on: { onPageChange: _vm.handlePageChange },
              scopedSlots: _vm._u(
                [
                  {
                    key: "thead",
                    fn: function() {
                      return [
                        _c("thead", [
                          _c("tr", [
                            _c(
                              "th",
                              [
                                _c(
                                  "base-sort-label",
                                  {
                                    on: {
                                      onChange: _vm.handleOnChangeSortProduct
                                    },
                                    model: {
                                      value: _vm.sort.product,
                                      callback: function($$v) {
                                        _vm.$set(_vm.sort, "product", $$v)
                                      },
                                      expression: "sort.product"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.$t("message.item")) +
                                        "\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("th", { staticClass: "text-center no-sort" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("apps.inventory.message.warningstock")
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _vm.hasAnyMaxStock
                              ? _c(
                                  "th",
                                  { staticClass: "text-center no-sort" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "apps.inventory.message.maxstock"
                                        )
                                      )
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticClass: "no-sort",
                                staticStyle: { "max-width": "200px" }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("apps.inventory.message.binlocation")
                                  )
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              { staticClass: "text-center" },
                              [
                                _c(
                                  "base-sort-label",
                                  {
                                    on: {
                                      onChange: _vm.handleOnChangeSortInstock
                                    },
                                    model: {
                                      value: _vm.sort.instock,
                                      callback: function($$v) {
                                        _vm.$set(_vm.sort, "instock", $$v)
                                      },
                                      expression: "sort.instock"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t(
                                            "apps.inventory.message.balance"
                                          )
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.hasAnyUnit
                              ? _c(
                                  "th",
                                  { staticClass: "text-center no-sort" },
                                  [_vm._v(_vm._s(_vm.$t("message.unit")))]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hasRoleEdit
                              ? _c("th", { staticClass: "no-sort" })
                              : _vm._e()
                          ])
                        ])
                      ]
                    },
                    proxy: true
                  },
                  {
                    key: "tbody",
                    fn: function() {
                      return [
                        _c(
                          "tbody",
                          [
                            _c("tr", [
                              _vm.stocks.length === 0
                                ? _c(
                                    "td",
                                    {
                                      staticClass: "text-center",
                                      attrs: { colspan: "6" }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.$t("message.notfounddata")
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.stocks, function(item, index) {
                              return _c("tr", { key: index }, [
                                _c("td", [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "d-flex align-items-center",
                                      staticStyle: { gap: "8px" }
                                    },
                                    [
                                      _vm.hasAnyImage
                                        ? _c("img", {
                                            attrs: {
                                              src: _vm.productImage(item.sku),
                                              width: "30",
                                              height: "30"
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("router-link-custom", {
                                        attrs: {
                                          to: {
                                            name: "ProductEdit",
                                            query: {
                                              pid: item.product.product_id,
                                              pname: item.product.product_name
                                            }
                                          },
                                          text: _vm.getProductFullName(
                                            item.product.product_name,
                                            item.sku.attributes
                                          ),
                                          to_appid: 2,
                                          current_appid: 3
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-center" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.getNumber(
                                          item.stock.control.minstock
                                        )
                                      ) +
                                      "\n            "
                                  )
                                ]),
                                _vm._v(" "),
                                _vm.hasAnyMaxStock
                                  ? _c("td", { staticClass: "text-center" }, [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.getNumber(
                                              item.stock.control.maxstock
                                            )
                                          ) +
                                          "\n            "
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticStyle: { "max-width": "200px" } },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "d-flex",
                                        staticStyle: { gap: "5px" }
                                      },
                                      _vm._l(
                                        _vm.getBinLocationNamesByStock(item),
                                        function(v, i) {
                                          return _c(
                                            "span",
                                            {
                                              key: i,
                                              staticClass:
                                                "badge badge-secondary"
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(v) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    staticClass: "text-center",
                                    attrs: { "data-order": item.stock.instock }
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.getNumber(item.stock.instock)
                                        ) +
                                        "\n            "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.hasAnyUnit
                                  ? _c("td", { staticClass: "text-center" }, [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(item.product.unit) +
                                          "\n            "
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.hasRoleEdit
                                  ? _c("td", { staticClass: "text-center" }, [
                                      _c("div", { staticClass: "dropdown" }, [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn no-bg dropdown-toggle",
                                            attrs: {
                                              id: "dropdownMenuButton",
                                              type: "button",
                                              "data-toggle": "dropdown",
                                              "aria-haspopup": "true",
                                              "aria-expanded": "false"
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "name" },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.$t("message.option")
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "dropdown-menu dropdown-menu-right",
                                            attrs: {
                                              "aria-labelledby":
                                                "dropdownMenuButton"
                                            }
                                          },
                                          [
                                            _c(
                                              "a",
                                              {
                                                staticClass: "dropdown-item",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.openStockWarningModal(
                                                      item
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fas fa-sort-numeric-down"
                                                }),
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "apps.inventory.message.warningstock"
                                                      )
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                staticClass: "dropdown-item",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.openStockBinModal(
                                                      item
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "fas fa-boxes"
                                                }),
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "apps.inventory.message.binlocation"
                                                      )
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("div", {
                                              staticClass: "dropdown-divider"
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                staticClass: "dropdown-item",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.openAdjustmentModal(
                                                      item.sku.sku_id
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "fas fa-redo-alt"
                                                }),
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "apps.inventory.message.adjustmentstock"
                                                      )
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                staticClass: "dropdown-item",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.openTransferModal(
                                                      item.sku.sku_id
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fas fa-exchange-alt"
                                                }),
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.$t("button.transfer")
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                staticClass: "dropdown-item",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.openAdjustmentModal(
                                                      item.sku.sku_id,
                                                      "manual issue"
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fas fa-sign-out-alt"
                                                }),
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "apps.inventory.message.manualissue"
                                                      )
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                staticClass: "dropdown-item",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.openAdjustmentModal(
                                                      item.sku.sku_id,
                                                      "manual return"
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fas fa-sign-in-alt",
                                                  staticStyle: {
                                                    transform: "rotate(180deg)"
                                                  }
                                                }),
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "apps.inventory.message.manualreturn"
                                                      )
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ])
                                    ])
                                  : _vm._e()
                              ])
                            })
                          ],
                          2
                        )
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                2542904474
              )
            })
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal bd-example-modal-lg",
        attrs: {
          id: "adjustmentModal",
          tabindex: "-1",
          role: "dialog",
          "aria-hidden": "true",
          "data-keyboard": "false",
          "data-backdrop": "static"
        }
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog modal-lg", attrs: { role: "document" } },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c("h5", { staticClass: "modal-title" }, [
                  _vm._v(
                    _vm._s(_vm.$t("apps.inventory.message.adjustmentstock"))
                  )
                ]),
                _vm._v(" "),
                !_vm.$store.state.app.loading
                  ? _c(
                      "button",
                      {
                        staticClass: "close",
                        attrs: { type: "button", "aria-label": "Close" },
                        on: {
                          click: function($event) {
                            return _vm.closeAdjustmentModal()
                          }
                        }
                      },
                      [
                        _c("span", { attrs: { "aria-hidden": "true" } }, [
                          _vm._v("×")
                        ])
                      ]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "modal-body" },
                [
                  _vm.isShowAdjustmentModal
                    ? _c("modal-adjustment", {
                        attrs: {
                          data: _vm.adjustmentData,
                          reason: _vm.reason,
                          sku_id: _vm.adjustmentSkuId
                        },
                        on: {
                          "update:data": function($event) {
                            _vm.adjustmentData = $event
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              !_vm.$store.state.app.loading
                ? _c("div", { staticClass: "modal-footer" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-light",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.closeAdjustmentModal()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("button.cancel")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-web",
                        attrs: {
                          disabled: _vm.adjustmentData.items.length == 0,
                          type: "button"
                        },
                        on: {
                          click: function($event) {
                            return _vm.updateStock()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("button.apply")))]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.$store.state.app.loading
                ? _c("div", { staticClass: "modal-footer" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-light",
                        attrs: { type: "button", disabled: "" }
                      },
                      [_vm._v(_vm._s(_vm.$t("button.cancel")))]
                    ),
                    _vm._v(" "),
                    _vm._m(0)
                  ])
                : _vm._e()
            ])
          ]
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal bd-example-modal-lg",
        attrs: {
          id: "issueModal",
          tabindex: "-1",
          role: "dialog",
          "aria-hidden": "true",
          "data-keyboard": "false",
          "data-backdrop": "static"
        }
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog modal-lg", attrs: { role: "document" } },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c("h5", { staticClass: "modal-title" }, [
                  _vm.reason == "manual issue"
                    ? _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("apps.inventory.message.manualissue"))
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.reason == "manual return"
                    ? _c("span", [
                        _vm._v(_vm._s(_vm.$t("apps.inventory.message.return")))
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                !_vm.$store.state.app.loading
                  ? _c(
                      "button",
                      {
                        staticClass: "close",
                        attrs: { type: "button", "aria-label": "Close" },
                        on: {
                          click: function($event) {
                            return _vm.closeIssueModal()
                          }
                        }
                      },
                      [
                        _c("span", { attrs: { "aria-hidden": "true" } }, [
                          _vm._v("×")
                        ])
                      ]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "modal-body" },
                [
                  _vm.isShowIssueModal
                    ? _c("modal-issue-return", {
                        attrs: {
                          data: _vm.adjustmentData,
                          sku_id: _vm.adjustmentSkuId,
                          reason: _vm.reason
                        },
                        on: {
                          "update:data": function($event) {
                            _vm.adjustmentData = $event
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              !_vm.$store.state.app.loading
                ? _c("div", { staticClass: "modal-footer" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-light",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.closeIssueModal()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("button.cancel")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-web",
                        attrs: {
                          disabled: _vm.adjustmentData.items.length == 0,
                          type: "button"
                        },
                        on: {
                          click: function($event) {
                            return _vm.updateStock()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("button.apply")))]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.$store.state.app.loading
                ? _c("div", { staticClass: "modal-footer" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-light",
                        attrs: { type: "button", disabled: "" }
                      },
                      [_vm._v(_vm._s(_vm.$t("button.cancel")))]
                    ),
                    _vm._v(" "),
                    _vm._m(1)
                  ])
                : _vm._e()
            ])
          ]
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal bd-example-modal-lg",
        attrs: {
          id: "stockwarningModal",
          tabindex: "-1",
          role: "dialog",
          "aria-hidden": "true",
          "data-keyboard": "false",
          "data-backdrop": "static"
        }
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog modal-lg", attrs: { role: "document" } },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c("h5", { staticClass: "modal-title" }, [
                  _vm._v(_vm._s(_vm.$t("apps.inventory.message.warningstock")))
                ]),
                _vm._v(" "),
                !_vm.$store.state.app.loading
                  ? _c(
                      "button",
                      {
                        staticClass: "close",
                        attrs: { type: "button", "aria-label": "Close" },
                        on: {
                          click: function($event) {
                            return _vm.closeStockWarningModal()
                          }
                        }
                      },
                      [
                        _c("span", { attrs: { "aria-hidden": "true" } }, [
                          _vm._v("×")
                        ])
                      ]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [
                _vm.stockwarningItemClone
                  ? _c("section", [
                      _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("label", [
                            _vm._v(
                              _vm._s(_vm.$t("apps.inventory.message.minstock"))
                            )
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value:
                                  _vm.stockwarningItemClone.stock.control
                                    .minstock,
                                expression:
                                  "stockwarningItemClone.stock.control.minstock"
                              }
                            ],
                            staticClass: "form-control text-select-all",
                            attrs: { type: "number" },
                            domProps: {
                              value:
                                _vm.stockwarningItemClone.stock.control.minstock
                            },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.stockwarningItemClone.stock.control,
                                  "minstock",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("label", [
                            _vm._v(
                              _vm._s(_vm.$t("apps.inventory.message.maxstock"))
                            )
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value:
                                  _vm.stockwarningItemClone.stock.control
                                    .maxstock,
                                expression:
                                  "stockwarningItemClone.stock.control.maxstock"
                              }
                            ],
                            staticClass: "form-control text-select-all",
                            attrs: { type: "number" },
                            domProps: {
                              value:
                                _vm.stockwarningItemClone.stock.control.maxstock
                            },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.stockwarningItemClone.stock.control,
                                  "maxstock",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ])
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("section", { staticClass: "mb-0" }, [
                  _c("div", { staticClass: "col-md-12 no-padding mb-0" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          _vm.$t(
                            "apps.inventory.message.notificationwhenlowstocklevel"
                          )
                        ) +
                        "\n              "
                    ),
                    _c(
                      "a",
                      {
                        attrs: {
                          href:
                            "https://www.treesoft.io/th/manual/inventory#stockcontrol",
                          target: "_blank"
                        }
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.$t("button.learnmore")) +
                            "\n                "
                        ),
                        _c("i", { staticClass: "fas fa-external-link-alt" })
                      ]
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              !_vm.$store.state.app.loading
                ? _c("div", { staticClass: "modal-footer" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-light",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.closeStockWarningModal()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("button.cancel")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-web",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.updateStockWarning()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("button.apply")))]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.$store.state.app.loading
                ? _c("div", { staticClass: "modal-footer" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-light",
                        attrs: { type: "button", disabled: "" }
                      },
                      [_vm._v(_vm._s(_vm.$t("button.cancel")))]
                    ),
                    _vm._v(" "),
                    _vm._m(2)
                  ])
                : _vm._e()
            ])
          ]
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal",
        attrs: {
          id: "printModal",
          tabindex: "-1",
          role: "dialog",
          "aria-hidden": "true",
          "data-keyboard": "false",
          "data-backdrop": "static"
        }
      },
      [
        _c(
          "div",
          {
            staticClass: "modal-dialog modal-lg-90-percent",
            attrs: { role: "document" }
          },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c(
                "div",
                {
                  staticClass: "modal-body p-0",
                  staticStyle: {
                    background: "#C9CCCE",
                    height: "660px",
                    overflow: "auto"
                  }
                },
                [
                  _vm.ready
                    ? _c("printpreview", {
                        staticClass: "print-template",
                        attrs: {
                          stocks: _vm.allStocks,
                          warehouse: { name: _vm.warehouse_name },
                          time: _vm.openedPrintPreviewTime
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-web",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.onclickPrint()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("button.print")))]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-light",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.closePrintModal()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("button.close")))]
                )
              ])
            ])
          ]
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal",
        attrs: {
          id: "transferModal",
          tabindex: "-1",
          role: "dialog",
          "aria-hidden": "true",
          "data-keyboard": "false",
          "data-backdrop": "static"
        }
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog modal-lg", attrs: { role: "document" } },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c("h5", { staticClass: "modal-title" }, [
                  _vm._v(_vm._s(_vm.$t("apps.inventory.message.transfer")))
                ]),
                _vm._v(" "),
                !_vm.$store.state.app.loading
                  ? _c(
                      "button",
                      {
                        staticClass: "close",
                        attrs: { type: "button", "aria-label": "Close" },
                        on: {
                          click: function($event) {
                            return _vm.closeTransferModal()
                          }
                        }
                      },
                      [
                        _c("span", { attrs: { "aria-hidden": "true" } }, [
                          _vm._v("×")
                        ])
                      ]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "modal-body" },
                [
                  _vm.isShowTransferModal
                    ? _c("modal-transfer", {
                        attrs: {
                          data: _vm.transferData,
                          sku_id: _vm.transferSkuId
                        },
                        on: {
                          "update:data": function($event) {
                            _vm.transferData = $event
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              !_vm.$store.state.app.loading
                ? _c("div", { staticClass: "modal-footer" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-light",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.closeTransferModal()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("button.cancel")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-web",
                        attrs: {
                          disabled: this.transferData.items.length == 0,
                          type: "button"
                        },
                        on: {
                          click: function($event) {
                            return _vm.updateStockTransfer()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("button.apply")))]
                    )
                  ])
                : _c("div", { staticClass: "modal-footer" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-light",
                        attrs: { type: "button", disabled: "" }
                      },
                      [_vm._v(_vm._s(_vm.$t("button.cancel")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-web",
                        attrs: { type: "button", disabled: "" }
                      },
                      [
                        this.transferData.items.length > 0
                          ? _c("i", { staticClass: "fas fa-spinner spin" })
                          : _c("span", [_vm._v(_vm._s(_vm.$t("button.apply")))])
                      ]
                    )
                  ])
            ])
          ]
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal bd-example-modal-lg",
        attrs: {
          id: "stockbinModal",
          tabindex: "-1",
          role: "dialog",
          "aria-hidden": "true",
          "data-keyboard": "false",
          "data-backdrop": "static"
        }
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog modal-lg", attrs: { role: "document" } },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c("h5", { staticClass: "modal-title" }, [
                  _vm._v(_vm._s(_vm.$t("apps.inventory.message.binlocation")))
                ]),
                _vm._v(" "),
                !_vm.$store.state.app.loading
                  ? _c(
                      "button",
                      {
                        staticClass: "close",
                        attrs: { type: "button", "aria-label": "Close" },
                        on: {
                          click: function($event) {
                            return _vm.closeStockBinModal()
                          }
                        }
                      },
                      [
                        _c("span", { attrs: { "aria-hidden": "true" } }, [
                          _vm._v("×")
                        ])
                      ]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.formStockBin.stock_id
                ? _c("div", { staticClass: "modal-body" }, [
                    _c("section", { staticClass: "mb-0" }, [
                      _c("div", { staticClass: "form-row" }, [
                        _c(
                          "div",
                          { staticClass: "col-md-12" },
                          [
                            _c("label", [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm.$t(
                                      "apps.inventory.message.binlocationlabel"
                                    )
                                  ) +
                                  "\n                  "
                              ),
                              _c("i", {
                                directives: [
                                  {
                                    name: "b-popover",
                                    rawName: "v-b-popover.hover.right",
                                    value: _vm.$t(
                                      "apps.inventory.message.hintforprimarybinlocation"
                                    ),
                                    expression:
                                      "$t('apps.inventory.message.hintforprimarybinlocation')",
                                    modifiers: { hover: true, right: true }
                                  }
                                ],
                                staticClass: "fas fa-info-circle",
                                staticStyle: { color: "#ccc" },
                                attrs: { title: _vm.$t("message.advise") }
                              })
                            ]),
                            _vm._v(" "),
                            _c("vue-bootstrap-autocomplete", {
                              attrs: {
                                data: _vm.warehouseBinCodes,
                                minMatchingChars: 1,
                                showOnFocus: true
                              },
                              model: {
                                value: _vm.formStockBin.input,
                                callback: function($$v) {
                                  _vm.$set(_vm.formStockBin, "input", $$v)
                                },
                                expression: "formStockBin.input"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.$store.state.app.loading
                ? _c("div", { staticClass: "modal-footer" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-light",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.closeStockBinModal()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("button.cancel")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-web",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.updateStockBin()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("button.apply")))]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.$store.state.app.loading
                ? _c("div", { staticClass: "modal-footer" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-light",
                        attrs: { type: "button", disabled: "" }
                      },
                      [_vm._v(_vm._s(_vm.$t("button.cancel")))]
                    ),
                    _vm._v(" "),
                    _vm._m(3)
                  ])
                : _vm._e()
            ])
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      { staticClass: "btn btn-web", attrs: { type: "button", disabled: "" } },
      [_c("i", { staticClass: "fas fa-spinner spin" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      { staticClass: "btn btn-web", attrs: { type: "button", disabled: "" } },
      [_c("i", { staticClass: "fas fa-spinner spin" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      { staticClass: "btn btn-web", attrs: { type: "button", disabled: "" } },
      [_c("i", { staticClass: "fas fa-spinner spin" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      { staticClass: "btn btn-web", attrs: { type: "button", disabled: "" } },
      [_c("i", { staticClass: "fas fa-spinner spin" })]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4811b574", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4811b574","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/inventory/stockcontrol/List.vue
// module id = null
// module chunks = 